import { useEffect, useState } from 'react';

export default function LiveStamp() {
  const [time, setTime] = useState('');
  useEffect(() => {
    function update() {
      const d = new Date();
      const h = String(d.getHours()).padStart(2, '0');
      const m = String(d.getMinutes()).padStart(2, '0');
      setTime(`${h}:${m}`);
    }
    update();
    const id = setInterval(update, 30000);
    return () => clearInterval(id);
  }, []);
  if (!time) return null;
  return (
    <span className="live-stamp">
      <span className="ls-dot" aria-hidden="true"></span>
      {time} בגבעת השלושה · ישראל
    </span>
  );
}
